(ns teamoesterreich.admin-mode.data.lr-statistic
  (:require [clojure.walk]
            [goog.json :as json]
            [teamoesterreich.admin-mode.data.backend :as backend]
            [teamoesterreich.ajax :as ajax]
            [teamoesterreich.util.download :as h-download]
            [teamoesterreich.util.log :as log]))



(defn get-lr-statistic [orgMask date done-fn]
  (ajax/auth-get> (backend/get-auth) (str backend/BASE_URL "/lr-statistic?orgMask=" orgMask "&date=" date "&")
                  (fn [r-list status]
                    (log/debug "get-lr-statistic done" r-list status)
                    (when (= status 200)
                      (done-fn
                        (clojure.walk/keywordize-keys (js->clj (json/parse r-list)))
                        )))))

(defn get-lr-statistic-csv [orgMask date]
  (h-download/open-download-url (backend/get-auth) (str "/download/lr-statistic?orgMask=" orgMask "&date=" date)))
